import { Capacitor } from "@capacitor/core";
import filesystem from "../filesystem/filesystem";
import { getExistingAssetUrl } from "./content";
import { toast } from "react-toastify";

export interface ICompany {
  id: number;
  name: string;
  displayName: string;
  domain: string;
  defaultLoginMethod: string;
  alternativeLoginMethod: string;
  allowRegistration: boolean;
  allowGuest: boolean;
  allowBroadcast: boolean;
  displayTenantNameInTenantList:boolean;
  hiddenDuration:boolean;
  hiddenEndHour:boolean;
  hiddenEndDate:boolean;
  hiddenStartDate:boolean;
  hiddenStartHour:boolean;
  hiddenNumDoc:boolean;
  sidebarButtonBorder:string;
  isGlobalGuestFullyEnabled : boolean;
  isLoginWithUsernameEnabled : boolean;
  disabledCustom2FactorForSubnet: boolean;
  languageDefault: string;

}

export interface ILanguage {
  id: number;
  name: string;
  locale: string;
  flagIcon: string;
}

export const applyCompanyTheme = async (company: ICompany, isNativeApp: boolean) => {
  const ts = new Date().getMilliseconds();
  //HTML TITLE
  document.title = company.displayName;

  //BACKGROUND
  let bgUrl = `${getExistingAssetUrl("companies", company.name, "background.png")}?ts=${ts}`;
  if (isNativeApp)
    bgUrl = Capacitor.convertFileSrc(await filesystem.GetLocalUrl.companyLogo(company, "background.png"));

  document.documentElement.style.setProperty(
    "--bgurl",
    `url(${bgUrl})`
  );

  //FAVICON
  const favicon = document.getElementById("favicon") as HTMLLinkElement;
  if (favicon)
    favicon.href = `${getExistingAssetUrl(
      "companies",
      company.name,
      "favicon.ico"
    )}?ts=${ts}`;
};

export interface ICompanyRegistrationSettings {
  enabledApprovalRegistrationRequest: boolean;
  enabledApprover: boolean;
  approverDomain: string;
  enabledDisclaimer : boolean;
  disclaimerDetails: ICompanyDisclaimerRegistrationDetail[]
  allLanguages: ILanguage[]
  enabledFirstName: boolean
  enabledLastName: boolean
  enabledPhoneNumber: boolean 
  enabledPassword: boolean 
  enabledfavouriteLanguage: boolean 
}
export interface ICompanyDisclaimerRegistrationDetail{
  languageId: number;
  description: string;
 }

 
export enum LoginType {
  no="no",
  owasp = "owasp",
  otp="otp",
  custom2factor="custom2factor",
  authenticatorapp="authenticatorapp",
}
